import { graphql } from "@acto/gql";
import { useQuery } from "urql";
import { KpiComparisonMode } from "@acto/taskpane/core/domain";
import { asCurrencyCode, CurrencyCode } from "@acto/taskpane/core/utils/currencyCode";
import { fromGqlKpiComparisonMode } from "@acto/taskpane/core/data-access/customers/kpiTransformers";

export const DEFAULT_CURRENCY = asCurrencyCode("EUR");
export const DEFAULT_COMPARISON_MODE = KpiComparisonMode.YEAR_OVER_YEAR;

const TenantSettingsQuery = graphql(`
  query GetTenantSettings {
    tenantSettings {
      currencyCode
      kpiComparisonMode
    }
  }
`);

export interface TenantSettings {
  currency: CurrencyCode;
  comparisonMode: KpiComparisonMode;
  resolved: boolean;
}

/**
 * `resolved` is false only until the first response lands, and stays true through any later
 * refetch. A failed request resolves to the defaults rather than surfacing the error.
 */
export const useTenantSettings = (): TenantSettings => {
  const [{ data, error, fetching }] = useQuery({ query: TenantSettingsQuery, requestPolicy: "cache-first" });
  const settings = data?.tenantSettings;

  return {
    currency: asCurrencyCode(settings?.currencyCode ?? DEFAULT_CURRENCY),
    comparisonMode: settings ? fromGqlKpiComparisonMode(settings.kpiComparisonMode) : DEFAULT_COMPARISON_MODE,
    resolved: !fetching || data !== undefined || error !== undefined,
  };
};
